const BankStatementOutlier = (() => {
    const init = (bankStatementDefaultConfig, resp) => {
        const outlierKey = 'account_level_monthly_activity';
        const outlierSubKey = 'summary';
        const defaultConfig = {
            x_axis_margin: 0.150,
            max_y_axis: 20000
        };
        if(!!resp && !resp.hasOwnProperty(outlierSubKey)) return;
        const outlierReportData = [], categories = [], series = [];
        for (let i = 0; i < Math.min(12, resp[outlierSubKey].length); ++i) {
            outlierReportData.push({
                deposits: resp[outlierSubKey][i]['deposits'],
                withdrawals: resp[outlierSubKey][i]['withdrawals']
            });
            defaultConfig.max_y_axis = Math.max(defaultConfig.max_y_axis, Math.max(resp[outlierSubKey][i]['deposits'], resp[outlierSubKey][i]['withdrawals']));
            categories.push(resp[outlierSubKey][i]['month_year']);
        }
        if (!bankStatementDefaultConfig.body || !bankStatementDefaultConfig.body.config) return;
        if (!bankStatementDefaultConfig.body.config[outlierKey] || !bankStatementDefaultConfig.body.config[outlierKey].outlier_report) return;
        const config = bankStatementDefaultConfig.body.config[outlierKey]['outlier_report'];
        defaultConfig.x_axis_margin = -1 * (config.seriesData.length / 2) * defaultConfig.x_axis_margin;
        for (let i = 0; i < config.seriesData.length; ++i) {
            series.push({
                name: config.seriesData[i].name,
                color: config.seriesData[i].color,
                data: [],
                type: 'column'
            });
            series.push({
                name: config.seriesData[i].name,
                color: config.seriesData[i].color,
                data: [],
                type: 'line'
            });
            const type = config.seriesData[i].name.toString().trim().toLowerCase() === 'credit';
            for (let j = 0; j < outlierReportData.length; ++j) {
                series[series.length - 1].data.push({
                    x: j - ((i & 1) ? +1 : -1) * defaultConfig.x_axis_margin,
                    y: outlierReportData[j][type ? 'deposits' : 'withdrawals']
                });
                series[series.length - 2].data.push(outlierReportData[j][type ? 'deposits' : 'withdrawals']);
            }
        }
        Highcharts.chart('WidgetMonthlyActivityOutlier', {
            chart: {
                zoomType: 'xy'
            },
            title: {
                text: (!!config['title']) ? config['title'] : ''
            },
            subtitle: {
                text: (!!config['subtitle']) ? config['subtitle'] : ''
            },
            xAxis: [{
                categories: categories,
                crosshair: true
            }],
            yAxis: [
                {
                    min: (-1 * defaultConfig.max_y_axis - 15000),
                    max: (defaultConfig.max_y_axis + 15000),
                    // tickInterval: 10000,
                    labels: {
                        formatter: function() {
                            return '$' + initScript.separateNumberByDelimiter(this.value);
                        },
                        style: {
                            color: Highcharts.getOptions().colors[1]
                        }
                    },
                    title: {
                        margin: 200,
                        text: null,
                        style: {
                            color: "#000",
                        },
                    },
                }
            ],
            credits: {
                enabled: false
            },
            plotOptions: {
                series: {
                    pointWidth: 25,
                }
            },
            tooltip: {
                shared: true,
                pointFormatter: function() {
                    return (this.name || this.series.name) + ' ($) : <b>'  + initScript.separateNumberByDelimiter(this.y ? this.y : 0) + '</b><br>';
                }
            },
            series: series
        }, function(chart) {
             const legend = chart.legend;

                if (legend.display) {
                    legend.group.hide();
                    legend.box.hide();
                    legend.display = false;
                } else {
                    legend.group.show();
                    legend.box.show();
                    legend.display = true;
                }
            });
    };
    return {
        init
    };
})();
